import { getLocale } from '@umijs/max';
import { isVietnameseLocale } from './locale';

type ApiErrorPayload = {
  code?: string;
  message?: string;
  detail?: string;
  error?: string;
};

type LocalizedText = {
  en: string;
  vi: string;
};

const ERROR_CODE_OVERRIDES: Record<string, LocalizedText> = {
  USER_PASSWORD_REUSED: {
    en: 'Password must not match one of the recent 24 passwords',
    vi: 'Mật khẩu mới không được trùng với 24 mật khẩu gần nhất',
  },
};

const ERROR_MESSAGE_OVERRIDES: Record<string, LocalizedText> = {
  'Invalid activation key': {
    en: 'Invalid activation key',
    vi: 'Activation key không hợp lệ',
  },
  'Invalid username or password': {
    en: 'Invalid username or password',
    vi: 'Sai tên đăng nhập hoặc mật khẩu',
  },
};

function getLocalizedText(text: LocalizedText): string {
  return isVietnameseLocale(getLocale?.()) ? text.vi : text.en;
}

function readPayload(error: any): ApiErrorPayload | undefined {
  const candidates = [
    error?.response?.data,
    error?.data,
    error?.info?.data,
    error?.info,
  ];

  for (const item of candidates) {
    if (item && typeof item === 'object') {
      return item as ApiErrorPayload;
    }
  }
  return undefined;
}

export function extractApiErrorCode(error: any): string | undefined {
  return readPayload(error)?.code;
}

export function resolveApiErrorMessage(error: any, fallback: string): string {
  const payload = readPayload(error);
  const code = payload?.code;

  if (code && ERROR_CODE_OVERRIDES[code]) {
    return getLocalizedText(ERROR_CODE_OVERRIDES[code]);
  }

  if (payload?.message && ERROR_MESSAGE_OVERRIDES[payload.message]) {
    return getLocalizedText(ERROR_MESSAGE_OVERRIDES[payload.message]);
  }

  return (
    payload?.message ||
    payload?.detail ||
    payload?.error ||
    error?.message ||
    fallback
  );
}
